<app-dropdown
	[itemGroups]="itemGroups$ | async"
	[value]="selectedFilterText$ | async"
	(onSelect)="onSelect($event)"
	(onFocus)="onFocus()"
	class="[&_*.container]:px-3 [&_*.container]:py-2 [&_*.container]:border-gray-200 [&_*.container]:text-sm"
></app-dropdown>
